<p class="error-message">{{ text() | translate }}</p>
